import { createSignal } from 'solid-js'
import type { Entity } from '../../lib/core/entity'
import createSharedCachedFactory from '../memo/createSharedCachedFactory'
import { isPlainObjListDeeplyEqual } from '../../lib/isPlainObjListDeeplyEqual'

export const useSelectedPositionEntsSignal = createSharedCachedFactory(() => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Array<Entity>>([], {
    equals: isPlainObjListDeeplyEqual,
  })

  return signal
})
